import { Card, FormLabel } from 'react-bootstrap';
import { accountNumberMask } from '../../utils/utils';
import Avatar, { AvatarSize, AvatarStatus } from '../Avatar';
import Radio from '../Radio';

export type selectableBankCardVariant = 'white' | 'transparent';

export type SelectableBankCardProps = {
  item?: any;
  className?: string;
  selected?: boolean;
  variant?: selectableBankCardVariant;
};

const SelectableBankCard = ({
  item,
  className,
  selected,
  variant = 'white',
}: SelectableBankCardProps) => {
  const { id, name, iban } = item;

  return (
    <FormLabel className="cnd-bank-wrapper">
      <Card
        bsPrefix={'cnd-bank-card'}
        className={`d-flex flex-column align-items-center position-relative bg-white ${className} ${
          selected ? 'selected' : ''
        } ${variant}`}
      >
        <Radio value={id} className={'position-absolute radio-custom'} />
        <div
          className={
            'cnd-bank-card--image-wrapper d-flex justify-content-center align-items-center'
          }
        >
          <Avatar
            id={'1'}
            size={AvatarSize.LARGE}
            status={AvatarStatus.ENABLED}
            name={name}
          />
        </div>
        <Card.Body
          className={'d-flex flex-column align-items-center p-10 mt-0'}
        >
          <Card.Title className="text-center">{name}</Card.Title>
          <Card.Title className="text-center">
            {accountNumberMask(iban)}
          </Card.Title>
        </Card.Body>
      </Card>
    </FormLabel>
  );
};

export default SelectableBankCard;
